import React from 'react'
import { Close } from '@mui/icons-material'
import { Dialog, DialogContent, DialogTitle, IconButton, Typography } from '@mui/material'

export interface Props {
  open: boolean
  setOpen: (op: boolean) => void
  error: string
  setError: (e: string) => void
}

const DialogError: React.FC<Props> = ({ open, setOpen, error, setError }) => {
  const handleClose = () => {
    setError(null)
    setOpen(false)
  }
  return (
    <Dialog open={open} onClose={handleClose}>
      <IconButton
        aria-label="close"
        onClick={handleClose}
        sx={{
          color: (theme) => theme.palette.grey[500],
          position: 'absolute',
          right: 2,
          top: 2,
          zIndex: 1
        }}
      >
        <Close />
      </IconButton>
      <DialogTitle>Error de Facturación</DialogTitle>
      <DialogContent>
        <Typography>{error}</Typography>
      </DialogContent>
    </Dialog>
  )
}

export default DialogError
